import axios from '@/api/$axios'
import { isWechatBrowser } from '@/utils/wechat'
export default {
  create ({ creation }) {
    return axios.post(`/creations`, {
      creation
    })
  },
  preview ({ id, backgroundImage }) {
    return axios.post(`/creations/${id}/preview`, {
      backgroundImage
    })
  },
  generate ({ id, payType, backgroundImage }) {
    const wxPayType = isWechatBrowser() ? 'JSAPI' : 'NATIVE'
    return axios.post(`/creations/${id}/generate`, {
      payType, wxPayType, backgroundImage
    })
  }
}
